// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3E2o5","label":"Completed_label__3Ny25"};